import styled from 'styled-components';

export const BenefitsContainer = styled.div`
  background: #FFFAF2;
  padding: 100px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    padding: 25px 0;
  }
`;

export const BenefitsContent = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 0 32px;
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  justify-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const BenefitCard = styled.div`
  width: 100%;
  max-width: 350px;
  height: 500px;
  perspective: 1000px;
  cursor: pointer;
  
  &:hover .card-inner {
    transform: rotateY(180deg);
  }
  
  /* Ensure the card-inner class is properly targeted */
  .card-inner {
    transition: transform 0.8s;
    transform-style: preserve-3d;
  }
`;

export const CardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
  
  /* Add class name for targeting */
  &.card-inner {
    transition: transform 0.8s;
    transform-style: preserve-3d;
  }
`;

export const CardFront = styled.div<{ frontBg: string }>`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background: ${props => props.frontBg};
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

export const CardBack = styled.div<{ frontBg: string }>`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  background: ${props => props.frontBg};
  border-radius: 20px;
  transform: rotateY(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

export const PhoneContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const PhoneImage = styled.img`
  max-width: 100%;
  height: auto;
  z-index: 2;
  position: relative;
`;

export const GradientOverlay = styled.div<{ gradientColor: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(${props => props.gradientColor});
  z-index: 1;
`;

export const CardContent = styled.div<{ contentBg: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${props => props.contentBg};
  padding: 30px 20px;
  border-radius: 20px;
  z-index: 3;
`;

export const CardTitle = styled.h3`
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: #ffffff;
  margin: 0 0 15px 0;
  text-align: center;
`;

export const CardDescription = styled.p`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin: 0;
  text-align: center;
  opacity: 0.9;
`;

export const BackImage = styled.img`
  max-width: 80%;
  height: auto;
  border-radius: 10px;
`;
